module.exports = __webpack_public_path__ + "static/media/file.685cd2ca.svg";